




























































































































































































import "./legal.less";
import Vue from "vue";

export default Vue.extend({
  name: "PrivacyModal",
  components: {},
  props: {
    showDialog: Boolean,
  },
  data() {
    return {};
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
      }
    },
  },
  computed: {
    showModal: {
      get() {
        return (this as any).showDialog;
      },
      set: function () {
        this.$emit("cancel");
      },
    },
  },
  methods: {},
});
